import { Card } from "antd";
import React from "react";

function Dashboard() {
  return (
    <Card style={{ textAlign: "center", paddingTop: 25, paddingBottom: 25 }}>
      <b>Coming Soon</b>
    </Card>
  );
}

export default Dashboard;
